import React, { useState } from 'react'
import styled from 'styled-components'
import AddressAutocomplete from '../shared/AddressAutocomplete'
import MapView from '../shared/MapView'
import axios from 'axios'
const apiUrl =
    process.env.NODE_ENV === 'production'
        ? '/api'
        : process.env.REACT_APP_API_URL

const StyledUpdatePrivateProfile = styled.div``
const StyledForm = styled.form`
    padding: 40px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    div {
        display: flex;
        label {
            width: 200px;
        }
        div {
            display: flex;
            flex-direction: column;
        }
    }
`
const StyledModifyButton = styled.div`
    justify-content: center;
    background-color: #1c8516;
    color: white;
    border-radius: 50px;
    padding: 5px;
    margin: auto;
    width: 150px;
    &:hover {
        cursor: pointer;
    }
`
const StyledDeleteButton = styled.div`
    justify-content: center;
    background-color: #7a0000;
    color: white;
    border-radius: 50px;
    padding: 5px;
    margin: auto;
    width: 150px;
    &:hover {
        cursor: pointer;
    }
`

const UpdatePrivateProfile = ({ setIsDeleteVisible, userInfo }) => {
    const [email, setEmail] = useState(userInfo?.email || '')
    const [password, setPassword] = useState('')
    const [birth, setBirth] = useState(
        userInfo?.birth ? userInfo.birth.split('T')[0] : ''
    )
    const [phone, setPhone] = useState(userInfo?.phone || '')
    const [previewUrl, setPreviewUrl] = useState(userInfo?.pictureUrl || '')
    const [selectedFile, setSelectedFile] = useState(null)
    const [address, setAddress] = useState(null)

    const handleSubmit = async (e) => {
        e.preventDefault()

        const formData = new FormData()
        const lat = address.lat
        const lon = address.lon

        const userData = {
            email,
            password,
            birth,
            phone,
            lat,
            lon,
        }

        formData.append('user', JSON.stringify(userData))

        if (selectedFile) {
            formData.append('image', selectedFile)
        }

        try {
            const response = await axios.put(
                `${apiUrl}/auth/changeInfo`,
                formData,
                {
                    withCredentials: true,
                }
            )
            console.log('Réponse du serveur:', response.data)
            window.location.replace('/Dashboard')
        } catch (error) {
            console.error(
                'Erreur lors de la requête:',
                error.response ? error.response.data : error.message
            )
        }
    }

    const handleFileChange = (e) => {
        const file = e.target.files[0]
        setSelectedFile(file)
        if (file) {
            setPreviewUrl(URL.createObjectURL(file))
        }
    }

    return (
        <StyledUpdatePrivateProfile>
            <StyledForm onSubmit={handleSubmit}>
                <h1>Modifier</h1>
                <div>
                    <label>Email (*)</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label>Mot de passe (*)</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        minLength={8}
                        required
                    />
                </div>
                <div>
                    <label>Date de naissance (*)</label>
                    <input
                        type="date"
                        value={birth}
                        onChange={(e) => setBirth(e.target.value)}
                        placeholder="birthdate"
                    />
                </div>
                <div>
                    <label>Téléphone</label>
                    <input
                        type="tel"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        pattern="[0-9]{10}"
                        maxLength="10"
                    />
                </div>

                <div>
                    <label>Photo (*)</label>
                    <div>
                        <div>
                            <input
                                type="file"
                                onChange={handleFileChange}
                                accept="image/*"
                            />
                            {previewUrl && (
                                <div>
                                    <img
                                        src={previewUrl}
                                        alt="Aperçu"
                                        style={{
                                            width: '100px',
                                            height: 'auto',
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div>
                    <label>Localisation (*)</label>
                    <AddressAutocomplete setAddress={setAddress} />
                </div>

                {address && <MapView lat={address.lat} lon={address.lon} />}

                {!email || !password || !birth || !previewUrl || !address ? (
                    <div>
                        Remplissez toutes les cases obligatoires (*) pour
                        pouvoir valider les modifications
                    </div>
                ) : (
                    <StyledModifyButton type="submit" onClick={handleSubmit}>
                        Modifier
                    </StyledModifyButton>
                )}
                <h1>Supprimer</h1>
                <p>Attention : la suppression du compte est définitive.</p>
                <StyledDeleteButton onClick={() => setIsDeleteVisible(true)}>
                    Supprimer
                </StyledDeleteButton>
            </StyledForm>
        </StyledUpdatePrivateProfile>
    )
}

export default UpdatePrivateProfile
